import styled from '@mui/system/styled';
import { colors } from 'components/theme/constants';

export const Container = styled('div')({
  '& .heading': {
    fontWeight: 600,
  },
  '& .total': {
    fontWeight: 700,
    fontSize: '16px',
  },
  '& .total-wrapper': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export const CostRowContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& .creator-select': {
    width: 180,
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  '& .delete-btn': {
    marginLeft: 6,
    color: '#9E9E9E',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: '1px solid #e5e5e5',
    marginBottom: 10,
  },

  '& .cost': {
    width: 300,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  '& .description': {
    marginInline: 12,
    [theme.breakpoints.down('sm')]: {
      marginInline: 'unset',
    },
  },
}));
